import { Offer } from 'pages/offerWallManager/slice';
import { OfferFieldValidationMessage } from '../constants';
function isOfferDisabled(offer: Offer) {
  const {
    offername,
    description,
    logourl,
    ctatext,
    headline,
    backgroundimgurl,
    comparisontext,
    comparisonemoji,
    label,
    fullscreenimageurl,
    category,
  } = offer;

  const errors = [];

  // Validate common fields
  if (!label) errors.push('Offer needs a label');
  if (!logourl) errors.push('Offer does not have a logo');

  const fieldsToValidate = [
    { field: offername, message: OfferFieldValidationMessage.OFFER_NAME },
    {
      field: backgroundimgurl,
      message: OfferFieldValidationMessage.BG_IMAGE_URL,
    },
    { field: headline, message: OfferFieldValidationMessage.HEADLINE },
    { field: description, message: OfferFieldValidationMessage.BODY },
    { field: ctatext, message: OfferFieldValidationMessage.CTA_TEXT },
    { field: headline, message: OfferFieldValidationMessage.SUBLINE },
    {
      field: comparisonemoji ? comparisontext : description,
      message: comparisonemoji
        ? OfferFieldValidationMessage.COM_TEXT
        : OfferFieldValidationMessage.DESCRIPTION,
    },
    {
      field: fullscreenimageurl,
      message: OfferFieldValidationMessage.FULL_SCREEN_IMAGE_URL,
    },
    {
      field: category,
      fieldName: 'category',
      message: OfferFieldValidationMessage.CATEGORY,
    },
  ];

  fieldsToValidate.forEach(({ field, fieldName, message }) => {
    if (fieldName == 'category' && Array.isArray(field) && field.length === 0) {
      errors.push(message);
    } else if (!field) errors.push(message);
  });

  return errors.length > 0;
}

export default isOfferDisabled;
